import React from 'react'

export default function RoutesPage() {
  return (
    <div>
      
    </div>
  )
}
